import {
    Box,
    Card,
    CardContent,
    Grid,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    useMediaQuery,
    Paper,
    Typography,
    Chip,
    TextField,
    TablePagination,
  } from '@mui/material';
  import React, { useEffect } from 'react';
  import DetailsCard from './Components/DetailsCard';
  import {
    EventTypeEnum,
    EventTypeLabels,
    GiftTypeEnum,
  } from '../../../utils/settings';
  import { useLocation } from 'react-router-dom';
  import { toast } from 'react-toastify';
  import { getGiftHistoryAction } from './APIs/action';
  import { GiftStatusEnum, REWARD_TABS } from './utils';
  
  const RewardHistory = () => {
    const isMobile = useMediaQuery('(max-width: 768px)');
    const location = useLocation();
    const [giftHistory, setGiftHistory] = React.useState([]);
    const receiver_id = location.state?.reciever_id;
    const type = location.state?.type;

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
  
    const fetchGiftHistory = async (receiver_id, type) => {
      const { data, message, error } = await getGiftHistoryAction(
        receiver_id,
        type,
      );
      if (!error) {
        setGiftHistory(data);
      } else {
        toast.error(message);
      }
    };
  
    useEffect(() => {
      if (receiver_id && type) {
        fetchGiftHistory(receiver_id, type);
      }
    }, [receiver_id, type]);
  
    const { receiver_details, gift_list, id } = giftHistory;
    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };
  
    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    };
    const paginatedGifts = gift_list ? gift_list.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : [];
  
    return (
      <Grid container spacing={2} sx={{ p: 3 }}>
        {receiver_details && (
          <Grid item xs={12}>
            <Card
              sx={{
                borderRadius: '12px',
                boxShadow:
                  '0 0 2px 0 rgba(145, 158, 171, 0.5), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
                p: 3,
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <Typography
                  variant="h6"
                  fontWeight="bold"
                  sx={{ mb: 3 }}
                  gutterBottom
                >
                  Basic Details
                </Typography>
                <Chip
                  label={receiver_details?.role}
                  sx={{
                    backgroundColor: 'primary.main',
                    color: 'white',
                    fontWeight: 'bold',
                  }}
                />
              </Box>
              <Grid container spacing={4}>
                <Grid item xs={12} sm={8}>
                  <Grid container spacing={2}>
                    <Grid item xs={6} sm={6}>
                      <Typography variant="subtitle2" fontWeight="bold" sx={{ color: '#636363', fontSize: '12px' }}>
                        Name
                      </Typography>
                      <TextField
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                          },
                        }}
                        fullWidth
                        margin="dense"
                        size="small"
                        value={receiver_details.name}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={6} sm={6}>
                      <Typography variant="subtitle2" fontWeight="bold" sx={{ color: '#636363', fontSize: '12px' }}>
                        Phone Number
                      </Typography>
                      <TextField
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                          },
                        }}
                        fullWidth
                        margin="dense"
                        size="small"
                        value={receiver_details.phone}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={6} sm={6}>
                      <Typography variant="subtitle2" fontWeight="bold" sx={{ color: '#636363', fontSize: '12px' }}>
                        State
                      </Typography>
                      <TextField
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                          },
                        }}
                        fullWidth
                        margin="dense"
                        size="small"
                        value={receiver_details.state}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={6} sm={6}>
                      <Typography variant="subtitle2" fontWeight="bold" sx={{ color: '#636363', fontSize: '12px' }}>
                        District
                      </Typography>
                      <TextField
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                          },
                        }}
                        fullWidth
                        margin="dense"
                        size="small"
                        value={receiver_details.district}
                        disabled
                      />
                    </Grid>
                  </Grid>
                </Grid>
  
                <Grid item xs={12} sm={4}>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      border: '1px solid #c5c5c5',
                      borderRadius: '10px',
                      flexDirection: 'column',
                      height: '100%',
                    }}
                  >
                    <Typography sx={{ mb: 2 }}>Current Month Business Volume</Typography>
                    <Typography variant="h6" fontWeight="bold" sx={{ color: 'orange', fontSize: '30px' }}>
                      {receiver_details?.current_month_business_volume || '-'}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Card>
          </Grid>
        )}
  
        <Grid item xs={12} md={12}>
          {!isMobile ? (
            <TableContainer component={Paper} sx={{ overflowX: 'auto' }}>
              <Table>
                <TableHead>
                  <TableRow sx={{ background: '#f4f6f8', borderBottom: '1px dashed #919eab33' }}>
                    {type !== 'SELF' && (
                      <TableCell sx={{ color: '#637381', fontWeight: 'bold', borderBottom: 'none' }}>
                        Beneficiary
                      </TableCell>
                    )}
                    {type !== 'SELF' && (
                      <TableCell sx={{ color: '#637381', fontWeight: 'bold', borderBottom: 'none' }}>
                        Role
                      </TableCell>
                    )}
                    <TableCell sx={{ color: '#637381', fontWeight: 'bold', borderBottom: 'none' }}>Gift Name</TableCell>
                    <TableCell sx={{ color: '#637381', fontWeight: 'bold', borderBottom: 'none' }}>Gift Status</TableCell>
                    <TableCell sx={{ color: '#637381', fontWeight: 'bold', borderBottom: 'none' }}>
                      Status change Date
                    </TableCell>
                    <TableCell sx={{ color: '#637381', fontWeight: 'bold', borderBottom: 'none' }}>Event Type</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {console.log(type)}
                  {gift_list ? (
                    paginatedGifts.map((gift, index) => {
                      const statusData = Object.values(GiftStatusEnum).find((s) => s.status === gift.status);
                      return (
                        <TableRow key={index} sx={{ borderBottom: '1px dashed #919eab33' }}>
                          {type !== 'SELF' && (
                            <TableCell sx={{ borderBottom: 'none' }}>{gift.beneficiary_name}</TableCell>
                          )}
                          {type !== 'SELF' && (
                            <TableCell sx={{ borderBottom: 'none' }}>{gift.beneficiary_role}</TableCell>
                          )}
                          <TableCell sx={{ borderBottom: 'none' }}>{gift.gift_product_name}</TableCell>
                          <TableCell sx={{ borderBottom: 'none', color: statusData?.color }}>
                            {statusData?.label}
                          </TableCell>
                          <TableCell sx={{ borderBottom: 'none' }}>{gift.status_change_date}</TableCell>
                          <TableCell sx={{ borderBottom: 'none' }}>{EventTypeLabels[gift.event_type]}</TableCell>
                        </TableRow>
                      );
                    })
                  ) : (
                    <TableRow sx={{ borderBottom: '1px dashed #919eab33' }}>
                      <TableCell colSpan={6} align="center">
                        No data available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={gift_list?.length || 0}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </TableContainer>
          ) : (
            <Box>
              {gift_list ? (
                gift_list.map((gift, index) => {
                  const statusData = Object.values(GiftStatusEnum).find((s) => s.status === gift.status);
                  return (
                    <Card key={index} sx={{ mb: 1, borderRadius: '12px', boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.5)' }}>
                      <CardContent sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Box>
                          {type !== REWARD_TABS['NETWORK'] && (
                            <Typography variant="body2">Beneficiary: {gift.beneficiary_name}</Typography>
                          )}
                          {type !== REWARD_TABS['NETWORK'] && (
                            <Typography variant="body2">Role: {gift.beneficiary_role}</Typography>
                          )}
                          <Typography variant="body2">Gift Name: {gift.gift_product_name}</Typography>
                          <Typography variant="body2">
                            Gift Status: <span style={{ color: statusData.color }}>{statusData?.label}</span>
                          </Typography>
                          <Typography variant="body2">Status change Date: {gift.status_change_date}</Typography>
                          <Typography variant="body2">Event Type: {EventTypeLabels[gift.event_type]}</Typography>
                        </Box>
                      </CardContent>
                    </Card>
                  );
                })
              ) : (
                <Typography align="center">No data available</Typography>
              )}
            </Box>
          )}
        </Grid>
      </Grid>
    );
  };
  
  export default RewardHistory;
  